import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { Option } from '@app/components/options-list/options-list.component';

export interface ProtectionItem {
  options: Option[];
  title: string;
  value: number;
  pricePerPerson: number;
}

@Component({
  selector: 'protection-select',
  templateUrl: './protection-select.component.html',
  styleUrls: ['./protection-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProtectionSelectComponent {
  @Input() options: ProtectionItem[];
  @Input() value: number;

  @Output() selectProtection = new EventEmitter<number>();
}
